import { render } from "./GoldArchiveLineComponent.vue?vue&type=template&id=f105d396"
import script from "./GoldArchiveLineComponent.vue?vue&type=script&lang=js"
export * from "./GoldArchiveLineComponent.vue?vue&type=script&lang=js"

import "./GoldArchiveLineComponent.vue?vue&type=style&index=0&id=f105d396&lang=scss"
script.render = render

export default script